export default __webpack_public_path__ + "static/media/OsamaAbdullah.8028ef95.png";